import { render, staticRenderFns } from "./ServiceTitleList.vue?vue&type=template&id=6189a88b&scoped=true&lang=pug&"
import script from "./ServiceTitleList.vue?vue&type=script&lang=js&"
export * from "./ServiceTitleList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTitleList.vue?vue&type=style&index=0&id=6189a88b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189a88b",
  null
  
)

export default component.exports